module.exports = __webpack_public_path__ + "img/_default_2.8cac6a52.svg";